<template>
  <div>
    <!-- DISPLAY AS DROPDOWN -->
    <div v-if="displayDropdown" class="field-dropdown">
      <p v-if="pFieldValue.multiple" class="help-block" v-html="pDictionary['dictionary.field.list.multiple.hint']"></p>
      <select :id="pFieldValueInputId" :name="fieldValueInputName" :multiple="pFieldValue.multiple" :size="dropdownSize"
              :class="['form-control', pFieldValue.state]" v-model="selectedOptionIds">
        <option v-if="!pFieldValue.multiple" value="-1">
          {{ 'dictionary.module.instance.option.select' | i18nText(pDictionary) }}
        </option>
        <option v-for="optionRef in pFieldValue.allOptionRefs"
                :key="optionRef.id"
                :value="optionRef.id">
          {{ i18nRefName(optionRef, pLanguage) }}
        </option>
      </select>
    </div>

    <!-- DISPLAY AS RADIO/CHECKBOX -->
    <div v-else class="field-checkbox">
      <span v-if="pFieldValue.allOptionRefs.length === 0" class="emptyOrNull">{{ 'dictionary.general.none' | i18nText(pDictionary) }}</span>
      <div class="row">
        <div v-for="optionRef in pFieldValue.allOptionRefs"
             :key="optionRef.id" :class="['field-checkbox-option', 'bs3-margin-bottom', 'col-xs-12', {'col-sm-4' : displayCheckboxInColumns}]">
          <input :type="fieldValueInputType" :name="fieldValueInputName" :value="optionRef.id"
                 v-model="selectedOptionIds" :class="pFieldValue.state"/>
          <span class="bs3-margin-left5">{{ i18nRefName(optionRef, pLanguage) }}</span>
        </div>
      </div>
    </div>

    <!-- OTHER OPTION -->
    <div v-if="pFieldValue.supportsOther" class="field-other">
      <span class="bs3-margin-right3">{{ 'dictionary.module.instance.other.value' | i18nText(pDictionary) }}:</span>
      <input type="text" :name="fieldValueOtherInputName" size="25" maxlength="100" :value="otherOption"
             class="form-control" style="max-width: 350px; display: inline-block"/>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "FieldValueListForm",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pFieldValue: {
      type: Object,
      required: true
    },
    pFieldValueInputId: {
      type: String,
      required: true
    },
    pFieldValueInputNamePrefix: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      selectedOptionIds: this.pFieldValue.multiple ?
                         this.pFieldValue.selectedOptionIds :
                         (this.pFieldValue.selectedOptionIds.length === 1 ?
                          this.pFieldValue.selectedOptionIds[0] : -1),
      otherOption: this.pFieldValue.value
    }
  },
  computed: {
    displayDropdown: function () {
      return this.pFieldValue.displayOption === 0;
    },
    dropdownSize: function () {
      return this.pFieldValue.multiple ? 5 : 1;
    },
    displayCheckboxInColumns: function () {
      return this.pFieldValue.displayOption === 1;
    },
    fieldValueInputType: function () {
      return this.pFieldValue.multiple ? 'checkbox' : 'radio'
    },
    fieldValueInputName: function () {
      return this.pFieldValueInputNamePrefix + ".selectedOptionIds";
    },
    fieldValueOtherInputName: function () {
      return this.pFieldValueInputNamePrefix + ".value";
    }
  }
}
</script>

<style scoped>

</style>